import {IResumenDiario, IUser} from '../utils/models';

export default class MeepoState {

    private readonly isAuthenticated: boolean = false;
    private readonly isLoading: boolean = true;
    private readonly isProcessLoading: boolean = false;
    private readonly usuarioPerfil: IUser;
    private readonly resumenDiarioXRuta: IResumenDiario[] = [];

    public constructor(oldState?: MeepoState) {
        if (oldState) {
            oldState = Object.assign(this, oldState);
            this.isAuthenticated = oldState.getIsAuthenticated();
            this.isLoading = oldState.getIsLoading();
        }
    }

    public getIsAuthenticated(): boolean {
        return this.isAuthenticated;
    }

    public getIsLoading(): boolean {
        return this.isLoading;
    }

    public getUsuarioPerfil(): IUser | undefined {
        return this.usuarioPerfil;
    }

    public getIsProcessLoading(): boolean {
        return this.isProcessLoading;
    }

    public getResumenDiarioXRuta(): IResumenDiario[] {
        return this.resumenDiarioXRuta;
    }

    public getRawState(): object {
        // can't use spread operator yet w/TS: https://github.com/Microsoft/TypeScript/pull/13288
        return Object.assign({}, this);
    }
}



// WEBPACK FOOTER //
// ./src/reduxstore/meepo-state.ts